<script>
import CardSvg from '@components/card-svg'

export default {
  components: { CardSvg },
  props: {
    selected: { type: String, default: '' },
  },
  data: () => ({
    types: [
      'american-express',
      'visa',
      'mastercard',
      'discover',
      'diners-club',
      'jcb',
      'unionpay',
    ],
  }),
}
</script>

<template>
  <div class="px-3 mb-6">
    <label class="label">Card type</label>
    <div class="flex flex-wrap">
      <CardSvg
        v-for="type in types"
        :key="type"
        :selected="selected"
        :type="type"
        class="w-16 mr-3 mb-3"
      />
    </div>
  </div>
</template>
